import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';

export const getBoxGroupStyle = (
  type: 'checkbox' | 'radio',
  compact = true,
): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  &&&.ant-${type}-group {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
  }
  &&& {
    .ant-${type}-wrapper {
      /**
   * TODO: add color to commons and use it here (https://enmontech.atlassian.net/browse/ENMON-1494)
   */
      color: #212529;
      position: relative;
      text-align: center;
      width: ${compact ? '32px' : '100px'};
      height: ${compact ? '32px' : '100px'};
      margin-right: 2px;
      margin-bottom: 2px;
      background-color: ${({ theme }) => theme.color.grey.grey4};
      border: 1px solid transparent;
      transition-property: all;
      transition-duration: 200ms;
      transition-timing-function: ease;

      i {
        font-size: ${({ theme }) => (compact ? theme.font.size.sm : theme.font.size['3xl'])}px;
        width: ${compact ? '16px' : 'auto'};
        height: ${compact ? '16px' : 'auto'};
        display: flex;
        align-items: center;
      }

      span {
        width: 100%;
        height: 100%;
        padding: unset;
      }

      &:has(:focus-visible) {
        background-color: ${({ theme }) => theme.color.grey.grey4};
        color: ${({ theme }) => theme.color.theme.primary};
        border: ${({ theme }) => `2px solid ${theme.color.theme.light}`};
      }

      &:hover {
        background-color: ${({ theme }) => theme.color.theme.lighterAlt};
        color: ${({ theme }) => theme.color.theme.dark};
      }

      &:active {
        background-color: ${({ theme }) => theme.color.theme.lighterAlt};
        color: ${({ theme }) => theme.color.theme.tertiary};
        border: none;
      }

      &:disabled {
        color: ${({ theme }) => theme.color.grey.grey6};
        background-color: ${({ theme }) => theme.color.grey.grey4};
      }

      &.ant-${type}-wrapper-checked {
        background-color: ${({ theme }) => theme.color.theme.lighterAlt};
        color: ${({ theme }) => theme.color.theme.tertiary};
        border: ${({ theme }) => `1px solid ${theme.color.theme.primary}`};

        &:hover {
          background-color: ${({ theme }) => theme.color.theme.lighterAlt};
          color: ${({ theme }) => theme.color.theme.dark};
          border: ${({ theme }) => `1px solid ${theme.color.theme.darkAlt}`};
        }
      }
    }
    .ant-${type} {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: -100;
    }
  }
`;
